import { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { getAgentList_action, sendAgentCredentials_action, sendAgentPIMail_action, view_agent_PI_action } from "../../../actions/admin_module_action/agent_entry_action/agent_action"
import { data } from "jquery";
import { toastError, toastSuccess, downloadReport } from "../../../utils/constants";
import ExhibitionDrawer from "../../../common_components/admin_module_drawer";
import ConfirmationModal from "../../../common_components/confirmationa_modal";




class Agentlist extends Component {

    // Initialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentAgentList: [],
            allAgentList: [],
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            loginAccesslist: []
        }
        this.onMixClick = this.onMixClick.bind(this)
        this.getAgentList = this.getAgentList.bind(this)
        this.onNationalClick = this.onNationalClick.bind(this)
        this.onInternationalClick = this.onInternationalClick.bind(this)
        this.onEdit = this.onEdit.bind(this)
        this.onView = this.onView.bind(this)
        this.onLoginClick = this.onLoginClick.bind(this)
        this.viewAgentPI = this.viewAgentPI.bind(this)
        this.onSendLoginCredClick = this.onSendLoginCredClick.bind(this)
        this.sendAgentPImail = this.sendAgentPImail.bind(this)
        this.getWriteAccess = this.getWriteAccess.bind(this)
        this.getUpdateAccess = this.getUpdateAccess.bind(this)
        this.getSpecialAccess = this.getSpecialAccess.bind(this)
        this.onEnroll = this.onEnroll.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.sendAgentPImail(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 1) {
                this.viewAgentPI(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 2) {
                this.sendAgentPImail(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 3) {
                this.viewAgentPI(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 4) {
                this.sendAgentPImail(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 5) {
                this.viewAgentPI(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 6) {
                this.sendAgentPImail(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 7) {
                this.viewAgentPI(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 8) {
                this.sendAgentPImail(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 9) {
                this.viewAgentPI(popArg[0], popArg[1], popArg[2])
            }
            if (confirmationObj.action == 10) {
                this.onSendLoginCredClick(popArg[0], popArg[1])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }



    // On Component Load
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getAgentList()
        sessionStorage.removeItem('IsAgentDirectLogin')
        sessionStorage.removeItem('indirectAgentloginDataSS')
    }

    // On Mix Click
    onMixClick(e) {
        e.preventDefault()
        this.props.navigate('/agententry', { state: { is_add: true, nationalityId: "mix" } })
    }

    // On national Click
    onNationalClick(e) {
        e.preventDefault()
        this.props.navigate('/agententry', { state: { is_add: true, nationalityId: "national" } })
    }

    // On International Click
    onInternationalClick(e) {
        e.preventDefault()
        this.props.navigate('/agententry', { state: { is_add: true, nationalityId: "international" } })
    }

    //on update
    onEdit(e, id, type) {
        console.log(type)
        e.preventDefault()
        this.props.navigate('/agententry', {
            state: {
                is_update: true,
                nationalityId: type,
                Account_Id: id
            }
        })
    }

    //enroll
    onEnroll(e, id, type, ExhibitionID) {
        e.preventDefault()
        this.props.navigate('/agententry', {
            state: {
                is_update: true,
                nationalityId: type,
                Account_Id: id,
                is_enroll: true,
                exhibitionID: ExhibitionID
            }
        })
    }

    //on view
    onView(e, id, type, is1stAgentPICreated, is2ndAgentPICreated, isManualPICreated, isTaxInvoiceCreated) {
        e.preventDefault()
        this.props.navigate('/agententry', {
            state: {
                is_view: true,
                nationalityId: type,
                Account_Id: id,
                is1stAgentPICreated: is1stAgentPICreated,
                is2ndAgentPICreated: is2ndAgentPICreated,
                isManualPICreated: isManualPICreated,
                isTaxInvoiceCreated: isTaxInvoiceCreated
            }
        })
    }

    // Get Agent List
    getAgentList() {
        this.setState({ isLoading: true })
        this.props.getAgentList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Agent Listing ----------------->", data)
                    this.setState({
                        isLoading: false,
                        currentAgentList: data.data.currentAgentList.length > 0 ? data.data.currentAgentList : [],
                        allAgentList: data.data.allAgentList.length > 0 ? data.data.allAgentList : []
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On send Login credentials Click
    onSendLoginCredClick(id, data) {
        this.setState({ isLoading: true })
        this.props.sendAgentCredentials_action(id)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess('The credentials shared successfully.')
                    this.setState({
                        isLoading: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // On Login Click
    onLoginClick(id, data) {
        console.log("1111111111111111111111", id, data)


        if (id == data['AccountID']) {
            console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
            var mapData = {
                "AccountID": data['AccountID'],
                "AccountName": data['AccountName'],
                "CompanyName": data['Company Name'],
                "CountryID": data['CountryID'],
                "CountryName": data['CountryName'],
                "FirstName": data['FirstName'],
                "LastName": data['LastName'],
                "RoleID": data['RoleID'],
                "RoleName": data['RoleName'],
                "UserID": data['UserID'],
                "AgentCode": data['agentcode'],
                "AgentRegistrationType": data['IsSelfPaid'] ? 2 : 1
            }
            // Prepare Session storage after Agent login Form admin
            sessionStorage.setItem('IsAgentDirectLogin', false)
            sessionStorage.setItem("indirectAgentuserEmailSS", data['PrimaryEmail'])
            sessionStorage.setItem("indirectAgenttokenSS", "token")
            sessionStorage.setItem("IndirectAgentAccountIDSS", data['AccountID'])
            sessionStorage.setItem("indirectAgentloginDataSS", JSON.stringify(mapData))
            console.log("login data", mapData['FirstName'].charAt(0))
            console.log("login data", mapData['LastName'].charAt(0))
            sessionStorage.setItem("indirectAgentfirstNameSS", mapData['FirstName'])
            sessionStorage.setItem("indirectAgentlastNameSS", mapData['LastName'])
            sessionStorage.setItem("indirectAgentprofileNameSS", `${mapData['FirstName'].charAt(0)}${mapData['LastName'].charAt(0)}`)

            // preparing Session storage for exhibition on login agnt from admin
            sessionStorage.setItem("indirectAgentsessionExhibitionID", data['ExhibitionID'])
            sessionStorage.setItem("indirectAgentExhibitionFromDateSS", data['FromDate'])
            sessionStorage.setItem("indirectAgentExhibitionToDateSS", data['ToDate'])
            sessionStorage.setItem("indirectAgentExhibitionAddressSS", data['Address'])
            setTimeout(() => {
                this.props.navigate("/agentdashboard");
            }, 200);
        }



    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '8');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '8');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '2');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '8');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '8');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }


    getSpecialAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '8');
        if (moduleAccess) {
            return moduleAccess.Is_SpecialAccess;
        } else {
            return false
        }
        return false;
    }

    sendAgentPImail(AccountID, currencyID, status) {
        this.setState({ isLoading: true })
        this.props.sendAgentPIMail_action(AccountID, currencyID, status)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess('Mail sent successfully')
                    this.setState({
                        isLoading: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    viewAgentPI(AccountID, currencyID, status) {
        this.setState({ isLoading: true })
        this.props.view_agent_PI_action(AccountID, currencyID, status)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log(data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                }
                else {

                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    render() {
        const { isLoading, allAgentList, currentAgentList, isOpenConfirmationModal } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer></ToastContainer>
                <HeaderWithLogo />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                <div className="page">
                    <ExhibitionDrawer />
                    <div className="page-main">
                        <div className="main-content app-content mt-0">
                            <div className="app-content with-dr-container com-height">
                                <div className="main-container">
                                    <div className="row m-0">
                                        <div className="breadcrumb-scroll-fixed">
                                            <div className="position-relative">
                                                <h6 className="mb-0 p-2 text-white">Agent List</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <main id="main" className="py-2 px-3 admin-top-space-add-routine">
                                        <div className="row mx-0">
                                            <div className="card border mb-3 p-0">

                                    {/* Card Header */}
                                    <div className="card-header  fw-semibold">
                                        Agent Registration
                                    </div>

                                    {/* Card Body */}
                                    <div className="card-body">
                                        {/* ACCORDION BEGIN */}
                                        <div className="row g-2">
                                            <div className="col-md-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua w-100"
                                                    disabled={!this.getWriteAccess()}
                                                    style={{ fontSize: 15 }}
                                                    onClick={(e) => this.onNationalClick(e)}
                                                >
                                                    National
                                                </button>
                                            </div>

                                            <div className="col-md-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua w-100"
                                                    disabled={!this.getWriteAccess()}
                                                    style={{ fontSize: 15 }}
                                                    onClick={(e) => this.onInternationalClick(e)}
                                                >
                                                    International
                                                </button>
                                            </div>

                                            <div className="col-md-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua w-100"
                                                    disabled={!this.getWriteAccess()}
                                                    style={{ fontSize: 15 }}
                                                    onClick={(e) => this.onMixClick(e)}
                                                >
                                                    Mix
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="main-container p-2">

                                <div className="row mt-1 m-0">
                                    <div className="table-responsive mb-3 p-0 mx-2">

                                        <h6 className="fw-semibold">
                                            Agent List for {sessionStorage.getItem("ExhibitionName")}
                                        </h6>
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-1 me-3">
                                            <thead class="table-light">
                                                <tr>
                                                    <th className="text-center">Type</th>
                                                    <th>Agent Code</th>
                                                    <th>Company Name</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th className="text-center">Mobile</th>
                                                    <th className="text-center">Total Area</th>
                                                    <th className="text-center">Booked Area</th>
                                                    <th className="text-center">Balance Area</th>
                                                    <th className="text-center">Total Exhibitor</th>
                                                    <th colSpan={2} className="text-center">1st Agent PI</th>
                                                    <th colSpan={2} className="text-center">2nd Agent PI</th>
                                                    <th colSpan={2} className="text-center">Tax Invoice</th>
                                                    <th colSpan={2} className="text-center">Manual PI</th>
                                                    <th colSpan={2} className="text-center">Open Side PI</th>


                                                    {this.getUpdateAccess() &&
                                                        <th />
                                                    }
                                                    <th />
                                                    {this.getSpecialAccess() &&
                                                        <th />
                                                    }
                                                    {this.getSpecialAccess() &&
                                                        <th />
                                                    }
                                                </tr>
                                            </thead>
                                            {console.log('currentAgentList', currentAgentList)}
                                            <tbody>
                                                {
                                                    currentAgentList.length > 0 ?
                                                        currentAgentList.map((data) => (
                                                            <tr key={Math.random()}>
                                                                <td className="text-center">{data.Type}</td>
                                                                <td>{data.agentcode}</td>
                                                                <td>{data['Company Name']}</td>
                                                                <td>{data.Name}</td>
                                                                <td>{data.PrimaryEmail}</td>
                                                                <td className="text-center">{data.MobileNo}</td>
                                                                <td className="text-center">{data['Total Area']}</td>
                                                                <td className="text-center">{data['Booked Area']}</td>
                                                                <td className="text-center">{data['Balance Area']}</td>
                                                                <td className="text-center">{data['Total Exhibitor']}</td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getSendAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-aqua"
                                                                            disabled={data.is1stAgentPICreated == 0}
                                                                            // onClick={(e) => this.sendAgentPImail(data.AccountID, data.currencyID, 1)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Send?`, buttonName: "Send", action: 0 }, popArg: [data.AccountID, data.currencyID, 1] })}
                                                                        >
                                                                            Send
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getDownloadAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-success btn-sm"
                                                                            disabled={data.is1stAgentPICreated == 0}
                                                                            // onClick={(e) => this.viewAgentPI(data.AccountID, data.currencyID, 1)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  View?`, buttonName: "View", action: 1 }, popArg: [data.AccountID, data.currencyID, 1] })}
                                                                        >
                                                                            View
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getSendAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-aqua"
                                                                            disabled={data.is2ndAgentPICreated == 0}
                                                                            // onClick={(e) => this.sendAgentPImail(data.AccountID, data.currencyID, 2)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Send?`, buttonName: "Send", action: 2 }, popArg: [data.AccountID, data.currencyID, 2] })}
                                                                        >
                                                                            Send
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getDownloadAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-success btn-sm"
                                                                            disabled={data.is2ndAgentPICreated == 0}
                                                                            // onClick={(e) => this.viewAgentPI(data.AccountID, data.currencyID, 2)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  View?`, buttonName: "View", action: 3 }, popArg: [data.AccountID, data.currencyID, 2] })}
                                                                        >
                                                                            View
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getSendAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-aqua"
                                                                            disabled={data.isTaxInvoiceCreated == 0}
                                                                            // onClick={(e) => this.sendAgentPImail(data.AccountID, data.currencyID, 3)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Send?`, buttonName: "Send", action: 4 }, popArg: [data.AccountID, data.currencyID, 3] })}
                                                                        >
                                                                            Send
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getDownloadAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-success btn-sm"
                                                                            disabled={data.isTaxInvoiceCreated == 0}
                                                                            // onClick={(e) => this.viewAgentPI(data.AccountID, data.currencyID, 3)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  View?`, buttonName: "View", action: 5 }, popArg: [data.AccountID, data.currencyID, 3] })}
                                                                        >
                                                                            View
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getSendAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-aqua"
                                                                            disabled={data.isManualPICreated == 0 || data.isManualPICreated == null}
                                                                            // onClick={(e) => this.sendAgentPImail(data.AccountID, data.currencyID, 4)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Send?`, buttonName: "Send", action: 6 }, popArg: [data.AccountID, data.currencyID, 4] })}
                                                                        >
                                                                            Send
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getDownloadAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-success btn-sm"
                                                                            disabled={data.isTaxInvoiceCreated == 0}
                                                                            // onClick={(e) => this.viewAgentPI(data.AccountID, data.currencyID, 4)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  View?`, buttonName: "View", action: 7 }, popArg: [data.AccountID, data.currencyID, 4] })}
                                                                        >
                                                                            View
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getSendAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-aqua"
                                                                            disabled={data.isOpenSidePICreated == 0}
                                                                            // onClick={(e) => this.sendAgentPImail(data.AccountID, data.currencyID, 5)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Send?`, buttonName: "Send", action: 8 }, popArg: [data.AccountID, data.currencyID, 5] })}
                                                                        >
                                                                            Send
                                                                        </button>}
                                                                </td>
                                                                <td>
                                                                    {data.IsSelfPaid && this.getDownloadAccess() &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-success btn-sm"
                                                                            disabled={data.isOpenSidePICreated == 0}
                                                                            // onClick={(e) => this.viewAgentPI(data.AccountID, data.currencyID, 5)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  View?`, buttonName: "View", action: 9 }, popArg: [data.AccountID, data.currencyID, 5] })}
                                                                        >
                                                                            View
                                                                        </button>}
                                                                </td>
                                                                {this.getUpdateAccess() &&
                                                                    <td>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-aqua-border py-1 btn-sm"
                                                                            onClick={(e) => this.onEdit(e, data.AccountID, data.AgentRegistrationType)}
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    </td>
                                                                }
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-aqua-border btn-sm"
                                                                        onClick={(e) => this.onView(e, data.AccountID, data.AgentRegistrationType, data.is1stAgentPICreated, data.is2ndAgentPICreated, data.isManualPICreated, data.isTaxInvoiceCreated)}
                                                                    >
                                                                        View
                                                                    </button>
                                                                </td>
                                                                {this.getSendAccess() &&
                                                                    <td>
                                                                        <button type="button" className="btn btn-aqua-border btn-sm"
                                                                            // onClick={(e) => this.onSendLoginCredClick(data.AccountID, data)}
                                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Send?`, buttonName: "Send", action: 10 }, popArg: [data.AccountID, data] })}
                                                                        >
                                                                            Send Login Credentials
                                                                        </button>
                                                                    </td>
                                                                }
                                                                {this.getSpecialAccess() &&
                                                                    <td>
                                                                        <button type="button" className="btn btn-aqua-border btn-sm"
                                                                            onClick={(e) => this.onLoginClick(data.AccountID, data)}
                                                                        >
                                                                            Login
                                                                        </button>
                                                                    </td>
                                                                }
                                                            </tr>
                                                        )) :
                                                        <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="row m-0 mt-1">
                                    <h6 className="fw-semibold">
                                        Un-Enrolled Agent List
                                    </h6>
                                    <div class="table-responsive mb-3 p-0 mx-2">
                                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-1 me-3">
                                            <thead class="table-light">
                                                <tr>
                                                    <th className="text-center">Type</th>
                                                    <th>Agent Code</th>
                                                    <th>Company Name</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th className="text-center">Mobile</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    allAgentList.length > 0 ?
                                                        allAgentList.map((data) => (
                                                            <tr key={Math.random()}>
                                                                <td className="text-center">{data.Type}</td>
                                                                <td>{data.agentcode}</td>
                                                                <td>{data['Company Name']}</td>
                                                                <td>{data.Name}</td>
                                                                <td>{data.PrimaryEmail}</td>
                                                                <td className="text-center">{data.MobileNo}</td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-aqua"
                                                                        onClick={(e) => this.onEnroll(e, data.AccountID, data.AgentRegistrationType, data.ExhibitionID)}
                                                                    >
                                                                        Enroll
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                        <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                                    </main>
                                </div>
                            </div>
                            <div className="footer-first">
                                <div className="container-fluid">
                                    <div className="footer-first">
                                        {" "}
                                        ITME All Rights Reserved{" "}
                                        <i className="fa fa-copyright" aria-hidden="true" /> 2023{" "}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        )
    }
}
export default withRouter(connect(null, { getAgentList_action, sendAgentCredentials_action, sendAgentPIMail_action, view_agent_PI_action })(Agentlist))